module.exports = __webpack_public_path__ + "media/press/law360-6cdffcd5.png";